import '../../../pages/Organization/OrganizationOld.scss';

import Paragraph from 'components/TextComps/Paragraph';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

export const NoInvitesLeft = observer(() => {
  const { t } = useTranslation();

  return (
    <div className='no-data-found'>
      <h2>{t('NoInvitesLeft', { ns: 'studentsPage' })}</h2>
      <Paragraph>
        <>{t('YouHaveNoInvitesLeft', { ns: 'studentsPage' })}</>
      </Paragraph>
    </div>
  );
});

export default NoInvitesLeft;
